import { createContext, useContext } from 'react';
import { Context } from './types';

export const ActionPlanSectionContext = createContext<Context>({} as Context);

export const useSectionActionPlan = () => {
	const actionPlanSectionContext = useContext(ActionPlanSectionContext);

	if (!actionPlanSectionContext) {
		throw new Error('useActionPlanSection has to be used within <ActionPlanSectionContext.Provider>');
	}

	return actionPlanSectionContext;
};
